import { useWindowSize } from 'utils/hooks/useWindowSize'
import { bigLg } from 'utils/style-utils'

import { gamesContainerPadding } from '../../styles'

export function useDesktopGamesGridWidth() {
  const { width } = useWindowSize()

  return Math.min(bigLg, width - gamesContainerPadding * 2)
}
